// Quién da de alta el trabajador de `public/sw.js`, y cuándo (roadmap móvil, 10 oct 2026).
//
// SOLO EN LO PUBLICADO Y CON HTTPS. En desarrollo un trabajador que guarda trozos es la forma
// más rápida de pasarse una tarde mirando un cambio que no aparece; y sin HTTPS el navegador no
// lo deja registrar de todas formas.
//
// DESPUÉS DE CARGAR, NO ANTES. Registrarlo compite por la red con la propia página, y en un
// móvil con mala cobertura la primera visita es justo la que no puede esperar a nadie.
//
// Y SI FALLA, NADA. La web funciona exactamente igual sin él: lo único que se pierde es el icono
// a pantalla completa y la página de «sin conexión».

export function registraElTrabajador({
  ventana = typeof window === "undefined" ? null : window,
  produccion = process.env.NODE_ENV === "production",
} = {}) {
  try {
    const nav = ventana?.navigator;
    if (!produccion || !nav?.serviceWorker || ventana.location?.protocol !== "https:") return false;
    const alta = () => { nav.serviceWorker.register("/sw.js", { scope: "/" }).catch(() => {}); };
    if (ventana.document?.readyState === "complete") alta();
    else ventana.addEventListener("load", alta, { once: true });
    return true;
  } catch {
    return false;
  }
}
